// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DefaultLayout_wrapper_-86Ok","button":"DefaultLayout_button_18Mz6"};